import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useSpring } from '@react-spring/web';
import { useMutationEffect } from './use-mutation-effect';
import { bound } from './bound';
import { useIsomorphicLayoutEffect } from 'ahooks';
import { useIsomorphicUpdateLayoutEffect } from './use-isomorphic-update-layout-effect';
export var useTabListScroll = function useTabListScroll(targetRef, activeIndex) {
  var _useSpring = useSpring(function () {
    return {
      scrollLeft: 0,
      config: {
        tension: 300,
        clamp: true
      }
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      scrollLeft = _useSpring2[0].scrollLeft,
      api = _useSpring2[1];

  function animate() {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var container = targetRef.current;
    if (!container) return;
    if (activeIndex === undefined) return;
    var activeTabWrapper = container.children.item(activeIndex);
    var activeTab = activeTabWrapper.children.item(0);
    var activeTabLeft = activeTab.offsetLeft;
    var activeTabWidth = activeTab.offsetWidth;
    var containerWidth = container.offsetWidth;
    var containerScrollWidth = container.scrollWidth;
    var containerScrollLeft = container.scrollLeft;
    var maxScrollDistance = containerScrollWidth - containerWidth;
    if (maxScrollDistance <= 0) return;
    var nextScrollLeft = bound(activeTabLeft - (containerWidth - activeTabWidth) / 2, 0, containerScrollWidth - containerWidth);
    api.start({
      scrollLeft: nextScrollLeft,
      from: {
        scrollLeft: containerScrollLeft
      },
      immediate: immediate && !scrollLeft.isAnimating
    });
  }

  useIsomorphicLayoutEffect(function () {
    animate(true);
  }, []);
  useIsomorphicUpdateLayoutEffect(function () {
    animate();
  }, [activeIndex]);
  useMutationEffect(function () {
    animate(true);
  }, targetRef, {
    subtree: true,
    childList: true,
    characterData: true
  });
  return {
    scrollLeft: scrollLeft,
    animate: animate
  };
};